














import SvgIcon from '@/components/SvgIcon';
import Button from '@/components/Controls/Button';
import { PropsMixin } from './PropsMixin';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    components: {
        SvgIcon,
        Button,
    },
})
export default class SliderLabels extends PropsMixin {
    /**
     *
     */
    @Prop()
    public readonly activeIndex!: number;
    /**
     *
     */
    public get labelsList() {
        const labels: string[] = [];
        const result: { glyph: string; indexes: number[] }[] = [];

        for (let i = 0; i < this.slides.length; i++) {
            const slide = this.slides[i];

            if (slide.label && !labels.includes(slide.label)) {
                result.push({ glyph: slide.label, indexes: [i] });
                labels.push(slide.label);
            } else {
                result[result.length - 1]?.indexes.push(i);
            }
        }

        return result;
    }
}
